"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _noPortalApiClient = _interopRequireDefault(require("hub-http/clients/noPortalApiClient"));

var _I18n = _interopRequireDefault(require("I18n"));

var _AnalyticsPeriod = _interopRequireDefault(require("hub-pickers-lib/constants/AnalyticsPeriod"));

var ACCOUNTS_API_BASE = '/accounts/v1/accounts';
var ANALYTICS_DATE_FORMAT = 'YYYYMMDD';
var ANALYTICS_PERIOD_ATTRIBUTE = 'accounts-dashboard:analytics-period';

var AccountsAPI = /*#__PURE__*/function () {
  function AccountsAPI() {
    (0, _classCallCheck2.default)(this, AccountsAPI);
  }

  (0, _createClass2.default)(AccountsAPI, null, [{
    key: "getAccounts",
    value: function getAccounts(includePins, includeStats) {
      return _noPortalApiClient.default.get(ACCOUNTS_API_BASE + "/", {
        timeout: 10000,
        query: {
          includePins: includePins,
          includeStats: includeStats
        }
      });
    }
  }, {
    key: "setPinnedAccounts",
    value: function setPinnedAccounts(pinnedAccounts) {
      return _noPortalApiClient.default.put(ACCOUNTS_API_BASE + "/pinned", {
        data: pinnedAccounts
      });
    }
  }, {
    key: "getAnalytics",
    value: function getAnalytics(analyticsPeriod) {
      var query;

      if (analyticsPeriod === _AnalyticsPeriod.default.THIRTY_DAY) {
        query = {
          currentPeriodStart: _I18n.default.moment.portalTz().subtract(31, 'day').format(ANALYTICS_DATE_FORMAT),
          currentPeriodEnd: _I18n.default.moment.portalTz().subtract(1, 'day').format(ANALYTICS_DATE_FORMAT),
          previousPeriodStart: _I18n.default.moment.portalTz().subtract(62, 'day').format(ANALYTICS_DATE_FORMAT),
          previousPeriodEnd: _I18n.default.moment.portalTz().subtract(32, 'day').format(ANALYTICS_DATE_FORMAT)
        };
      } else {
        var modifier = analyticsPeriod === _AnalyticsPeriod.default.MONTHLY ? 'month' : 'week';

        var currentPeriodStart = _I18n.default.moment.portalTz().startOf(modifier === 'week' ? 'isoWeek' : 'month');

        var currentPeriodEnd = _I18n.default.moment.portalTz();

        if (+currentPeriodStart > +currentPeriodEnd) {
          currentPeriodEnd = currentPeriodStart;
        }

        var previousPeriodStart = _I18n.default.moment.portalTz().subtract(1, modifier).startOf(modifier === 'week' ? 'isoWeek' : 'month');

        var previousPeriodEnd = _I18n.default.moment.portalTz().subtract(1, modifier);

        if (+previousPeriodStart > +previousPeriodEnd) {
          previousPeriodEnd = previousPeriodStart;
        }

        query = {
          currentPeriodStart: currentPeriodStart.format(ANALYTICS_DATE_FORMAT),
          currentPeriodEnd: currentPeriodEnd.format(ANALYTICS_DATE_FORMAT),
          previousPeriodStart: previousPeriodStart.format(ANALYTICS_DATE_FORMAT),
          previousPeriodEnd: previousPeriodEnd.format(ANALYTICS_DATE_FORMAT)
        };
      }

      return _noPortalApiClient.default.get(ACCOUNTS_API_BASE + "/analytics", {
        query: query
      });
    }
  }, {
    key: "getAnalyticsPeriod",
    value: function getAnalyticsPeriod(userId) {
      return _noPortalApiClient.default.get('/users/v1/app/attributes/temp-hubless', {
        query: {
          'user-id': userId,
          key: 'accounts-dashboard:analytics-period'
        }
      });
    }
  }, {
    key: "setAnalyticsPeriod",
    value: function setAnalyticsPeriod(userId, analyticsPeriod) {
      return _noPortalApiClient.default.post('/users/v1/app/attributes/temp-hubless', {
        data: {
          userId: userId,
          key: ANALYTICS_PERIOD_ATTRIBUTE,
          value: analyticsPeriod
        }
      });
    }
  }]);
  return AccountsAPI;
}();

exports.default = AccountsAPI;
module.exports = exports.default;